import { Skeleton } from '@chakra-ui/react';

import { SEARCH_ENGINE } from '@nocowanie/core/consts';

export const ListingSearchBarSkeleton = () => (
    <Skeleton
        height={{ base: '63px', lg: '66px' }}
        maxW={{ lg: SEARCH_ENGINE.LISTING_MAX_WIDTH }}
        mx="auto"
        mb={{ base: 2, md: 0 }}
    />
);
